module.exports = __webpack_public_path__ + "img/2.9bcc8a2e.png";